import React, {FC, JSXElementConstructor, ReactNode} from "react";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import {IconProps} from "@material-ui/core/Icon";
import {SvgIconProps} from "@material-ui/core/SvgIcon";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Typography from "@material-ui/core/Typography";
import {withStyles} from "@material-ui/core/styles";
import {matchPath, NavLink, useLocation} from "react-router-dom";
import {useTheme} from "@material-ui/core";
import {Roles} from "@evennt-tech/api-v2-core";
import BageAlert, {BadgeAlertProps} from "../BadgeAlert";
import FlexBox from "../Layout/FlexBox";
import useStyles from "./style";

type MenuItemProps = Partial<BadgeAlertProps> & {
  icon: FC<IconProps> | JSXElementConstructor<SvgIconProps>;
  onClick?: () => void;
  name: string;
  to: string;
  color?: string;
  selected?: boolean;
  subLabel?: string;
  id?: string;
  disabled?: boolean;
  userRole?: Roles;
  endIcon?: ReactNode;
};

export const NavList = withStyles(() => ({
  root: {
    outline: "none",
  },
}))(MenuList);

export const NavItem: FC<MenuItemProps> = ({
  icon: Icon,
  to,
  name,
  onClick,
  badgeCount,
  calculateBadgeCount,
  color,
  selected,
  subLabel,
  disabled,
  id,
  endIcon,
}) => {
  const location = useLocation();
  const classes = useStyles();
  const theme = useTheme();

  const match = matchPath(location.pathname, to);

  const isSelected = selected || !!match;
  const iconColor = isSelected
    ? theme.palette.primary.main
    : theme.palette.contrastIcon.main;
  const shouldRenderBadge =
    typeof badgeCount === "number" || !!calculateBadgeCount;

  return (
    <MenuItem
      to={disabled ? "#" : to}
      onClick={onClick}
      component={NavLink}
      id={id}
      classes={{
        root: classes.navItem,
        selected: classes.navItemSelected,
      }}
      selected={isSelected}
    >
      <ListItemIcon className={classes.navItemIcon}>
        <Icon style={{color: color || iconColor}} />
      </ListItemIcon>
      <FlexBox justifyContent="space-between" width={1}>
        <Typography
          color="inherit"
          variant="inherit"
          style={{
            alignSelf: "center",
            color: isSelected
              ? theme.palette.primary.main
              : color || theme.palette.contrastText.main,
          }}
        >
          {name}
        </Typography>
        {subLabel && (
          <Typography color="inherit" variant="h3" className={classes.subName}>
            {subLabel}
          </Typography>
        )}
        {shouldRenderBadge && (
          <BageAlert
            badgeCount={badgeCount}
            calculateBadgeCount={calculateBadgeCount}
          />
        )}
        {endIcon}
      </FlexBox>
    </MenuItem>
  );
};

export default NavItem;
